import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[altTranslate]',
  standalone: false
})
export class AltTranslateDirective implements OnInit {
  @Input('altTranslate') translateKey: string = '';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    if (this.translateKey) {
      // Imposta l'attributo translate-key per tracciabilità
      this.renderer.setAttribute(
        this.el.nativeElement,
        'translate-key',
        this.translateKey
      );

      // Ottieni la traduzione e imposta l'attributo alt
      this.translateService
        .get(this.translateKey)
        .subscribe((translatedValue: string) => {
          this.renderer.setAttribute(
            this.el.nativeElement,
            'alt',
            translatedValue
          );
        });
    }
  }
}
